import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AccountDTO } from '../../../../shared/account-dto';
import { CheckoutDTO } from '../../../../shared/checkout-dto';
import { ToolbarDTO } from '../../../../shared/toolbar-dto';
import { AccountService } from '../account.service';
import { CustomerService } from '../customer.service';
import { ToolbarService } from '../toolbar.service';

@Component({
  selector: 'pv-top-toolbar',
  templateUrl: './top-toolbar.component.html',
  styleUrls: ['./top-toolbar.component.scss']
})
export class TopToolbarComponent implements OnInit {
  @Output() onToggleSnav: EventEmitter<void> = new EventEmitter<void>();
  @Input() loggedIn: boolean;
  account: AccountDTO;
  checkoutDTO: CheckoutDTO;
  toolbarDTO: ToolbarDTO[];
  hide = false;

  constructor(
    private customerService: CustomerService,
    public router: Router,
    private accountService: AccountService,
    private toolbarService: ToolbarService
  ) { }

  ngOnInit() {
    console.log("TOOOOOOLBAR")
    // Subscribe to account
    this.account = this.accountService.account
    this.accountService.accountSubject
    .subscribe(account => this.account = account)

    // Subscribe to checkoutDTO
    this.checkoutDTO = this.customerService.checkoutDTO
    this.customerService.checkoutSubject
    .subscribe(checkoutDTO => this.checkoutDTO = checkoutDTO);

    // Subscribe to login for toolbar
    this.customerService.loginSubject
    .subscribe((x) => {
      console.log('subscribe to login subject', x)
      this.toolbarService.getToolbar()
    })

    // Subscribe to toolbarDTO
    this.toolbarDTO = this.toolbarService.toolbarDTO
    this.toolbarService.toolbarSubject
    .subscribe(toolbarDTO => this.toolbarDTO = toolbarDTO);
  }

  toggleSnav() {
    this.onToggleSnav.emit();
  }

  getCartKey() {
    return this.customerService.checkoutDTO.cart.cartKey
  }

  getCartLength() {
    return this.customerService.checkoutDTO
      .cart
      .items
      .reduce((sum, item) => Number(item.quantity) + sum, 0)
  }

  getArtist(i) {
    const artistToolbar = this.toolbarDTO.find(x => x.module && x.module.toLowerCase() == 'artist')
    const artists = artistToolbar.artists

    const col = 4;
    const row = Math.floor(artists.length / col)
    return artists[(i % col) * row + Math.floor(i / col)]
  }

  myGetArtists() {
    const artistToolbar = this.toolbarDTO.find(x => x.module && x.module.toLowerCase() == 'artist')
    const artists = artistToolbar.artists

    const columns = [[], [], [], []];
    let starter = 0;
    for (let i = 0; i < columns.length; i++) {
      const remainder = artists.length % 4;
      const height = Math.floor(artists.length / 4) + (remainder > i ? 1 : 0);
      columns[i] = artists.slice(starter, starter + height);
      starter += height;
    }

    const endResult = [];
    for (let i = 0; i < artists.length; i++) {
      const column = i % 4;
      const row = Math.floor(i / 4)
      endResult.push(columns[column][row])
    }

    return endResult;
  }

  getToolbarClass() {
    return this.account && this.account.accountStyles && this.account.accountStyles.inverse_toolbar
      ? 'inverse-toolbar'
      : 'normal-toolbar'
  }

  /**
   * Hides the storeToolbar for a second so the menu disappears
   */
  hideNav(event?: any) {
    if (event) {
      event.stopPropagation()
    }

    this.hide = true;
    const setBack = (_, context) => () => context.hide = false
    setTimeout(setBack(null, this), 200);
  }

  noProp(event: Event) {
    if (event) {
      event.stopPropagation()
    }
  }
}
